import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

export interface QuickActionEvent {
  category: string;
  action: string;
}

@Component({
  selector: 'tidy-location-modal',
  templateUrl: './location-modal.component.html',
  styleUrls: ['./location-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class LocationModalComponent {
  @Input() type: string | null = null;
  @Input() locationData: any = null;
  @Input() isLoading = false;
  @Output() closed = new EventEmitter<void>();
  @Output() quickAction = new EventEmitter<QuickActionEvent>();

  get title(): string {
    const titles: Record<string, string> = {
      weather: 'Weather',
      utilities: 'Utilities',
      trash: 'Trash & Recycling',
      pests: 'Pest Control',
      ordinances: 'Local Ordinances'
    };
    return titles[this.type || ''] || 'Location Info';
  }

  onClose(): void {
    this.closed.emit();
  }

  onQuickAction(action: string): void {
    this.quickAction.emit({ category: this.type || '', action });
  }

  hasUtilitiesData(): boolean {
    const utility = this.locationData?.attributes?.utility?.data;
    return !!(utility?.electric || utility?.water || utility?.gas);
  }

  hasOrdinancesData(): boolean {
    const ordinances = this.locationData?.attributes?.ordinances?.data;
    return ordinances && Object.keys(ordinances).length > 0;
  }

  getOrdinancesSummary(): { category: string; icon: string; summary: string }[] {
    const ordinances = this.locationData?.attributes?.ordinances?.data;
    if (!ordinances) {
      return [];
    }

    const result: { category: string; icon: string; summary: string }[] = [];

    if (ordinances.noise) {
      result.push({
        category: 'Noise',
        icon: 'volume_up',
        summary: ordinances.noise.summary || 'Noise regulations apply'
      });
    }
    if (ordinances.parking) {
      result.push({
        category: 'Parking',
        icon: 'local_parking',
        summary: ordinances.parking.summary || 'Parking restrictions apply'
      });
    }
    if (ordinances.rental) {
      result.push({
        category: 'Rental',
        icon: 'home',
        summary: ordinances.rental.summary || 'Rental regulations apply'
      });
    }

    return result;
  }
}
